module.exports = __webpack_public_path__ + "img/lobby_hosting_history.59e73547.png";